import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { CarfaxHistoryComponent }  from './carfax.history.component';
import { CarfaxService }           from './carfax.service';
import { CarfaxSettingsComponent } from './carfax.settings.component';
import { CarfaxStates }            from './carfax.states';
import { SharedModule }            from '../shared/shared.module';
import { TableModule }             from '../table/table.module';

@NgModule({
  declarations: [
    CarfaxHistoryComponent,
    CarfaxSettingsComponent
  ],
  entryComponents: [
    CarfaxHistoryComponent,
    CarfaxSettingsComponent
  ],
  imports: [
    SharedModule,
    TableModule,

    UIRouterModule.forChild({ states: CarfaxStates })
  ],
  providers: [
    CarfaxService
  ]
})
export class CarfaxModule {}
